export type QuotationDocumentType = 'DEV' | 'FIC' | 'DIPA' | 'CG' | 'GP';

export const DevisDocumentType = {
  DEV: 'DEV' as QuotationDocumentType,
  FIC: 'FIC' as QuotationDocumentType,
  DIPA: 'DIPA' as QuotationDocumentType,
  CG: 'CG' as QuotationDocumentType,
  GP: 'GP' as QuotationDocumentType,
};
